import {HANDLE_SUFFIX} from '../../constants/index'

const path = require('path')
const files = require.context('./', false, /.js$/)

let modules = {}

files.keys().forEach(key => {
  const name = path.basename(key, '.js')
  if (name !== 'index') {
    addSchemaHandle(files(key), name)
  }
})

function addSchemaHandle (fns, name) {
  Object.keys(fns).forEach(key => {
    modules[`${key === 'default' ? name : key}${HANDLE_SUFFIX}`] = fns[key]
  })
}

export default modules
